import { memo } from "react";
import { Divider } from "@mui/material";
import { SectionTitle } from "@/common/typography";
import ProjectBills from "./ProjectBills";
import ProjectBillsLegacy from "./ProjectBillsLegacy";

const ProjectBillsSection = memo(function ProjectBillsSection({
    project,
    billsPermission,
    updatePermission,
    handleBillsChange,
    showSaveAlert,
}) {
    return (
        <>
            <Divider sx={{ marginTop: 5, marginBottom: 5 }} />

            <SectionTitle>
                Bills{" "}
                {project.legacy_bills
                    ? " (legacy, requires manual saving)"
                    : ""}
            </SectionTitle>

            {project.legacy_bills ? (
                <ProjectBillsLegacy
                    projectQuoted={project.bid_quoted}
                    currency={project.currency}
                    projectId={project.id}
                    bills={project.bills || []}
                    disabled={!billsPermission || !updatePermission}
                    setProjectBills={handleBillsChange}
                />
            ) : (
                <ProjectBills
                    bills={project.bills || []}
                    setProjectBills={handleBillsChange}
                    currency={project.currency}
                    disabled={!billsPermission || !updatePermission}
                    showSaveAlert={showSaveAlert}
                />
            )}
        </>
    );
});

ProjectBillsSection.displayName = "ProjectBillsSection";

export default ProjectBillsSection;
